<template>
    <v-app>
        <v-snackbar
                v-model="snackbar"
                top=true
                color="red"
                timeout=4000
        >
            {{ errorMsg }}
            <v-btn
                    color="white"
                    icon
                    @click="snackbar = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-container class="mt-10">
            <div>
                <v-row>
                    <v-col cols="1">
                        <v-btn small rounded  icon @click="previousDay" class="mr-4"><v-icon>mdi-arrow-left</v-icon></v-btn>

                    </v-col>
                    <v-col cols="8">
                        <h2>Demandes Hyundai Connect Du {{ actualdatefr }}</h2>
                    </v-col>
                    <v-col cols="3">
                        <v-btn small rounded  icon @click="nextDay" class="mr-4"><v-icon>mdi-arrow-right</v-icon></v-btn>
                        <v-btn small rounded  @click="setToday" class="mr-4 float-right">Aujourd'hui</v-btn>
                    </v-col>
                </v-row>
            </div>
            <div v-if="loading">
                <v-row>
                    <v-col>
                        <v-flex align-center>
                            <v-img max-width="700px" src="@/assets/loader.gif"></v-img>
                        </v-flex>
                    </v-col>
                </v-row>
            </div>
            <div v-if="!loading && rdvs.length == 0">
                <v-row>
                    <v-col>
                        <v-alert color="indigo" dark>
                            <h3>Bonjour,<br>
                            Pas de rendez-vous pour aujourd'hui !</h3>
                        </v-alert>
                    </v-col>
                </v-row>
            </div>
            <v-divider></v-divider>
            <div v-for="rdv in rdvs" v-bind:key="rdv.id">
                <v-row v-if="rdv.assignedagentid == '' || rdv.assignedagentid == userId" style="background-color: rgba(255, 255, 255, .6);" class="mb-2">
                    <v-col>
                        <h4 class="text-left">Le {{rdv.computed.date}} à {{rdv.computed.heure}}</h4>
                        <p class="text-left">
                            Contacter {{rdv.name}} par {{rdv.contactmethod}}
                            <br>
                            GSM :
                                <span v-if="rdv.contactmethod == 'WhatsApp'"><a :href="'whatsapp://send?phone=' + rdv.computed.whatsappnumber">{{rdv.gsm}}</a></span>
                                <span v-if="rdv.contactmethod == 'Téléphone'"><a :href="'tel:'+rdv.computed.whatsappnumber">{{rdv.gsm}}</a></span>
                                <span v-if="rdv.contactmethod == 'Skype'">{{rdv.gsm}}</span>
                            <br>
                            Mail : {{rdv.mail}}
                            <span v-if="rdv.contactmethod == 'Skype'">
                            <br>
                                Skype : <a :href="'skype:'+rdv.skypeid+'?call'">{{rdv.skypeid}}</a>
                        </span>
                        </p>

                    </v-col>
                    <v-col class="text-left">
                        <v-btn v-if="rdv.assignedagentid == ''" color="primary" class="float-right" @click="acceptRdv(rdv)">J'accepte la mission</v-btn>
                        <v-btn v-if="rdv.assignedagentid == userId && rdv.customdata.statusappel == ''" color="primary" class="float-right" :to="{ name: 'ViewConnect', params: { id: rdv.id }}">Faire l'appel</v-btn>
                        <p v-if="rdv.assignedagentid == userId && rdv.customdata.statusappel != ''">
                            <strong>Status de l'appel :</strong> {{ rdv.customdata.statusappel }}<br>
                            <span v-if="rdv.customdata.budgetclient != ''"><strong>Budget du client :</strong>{{ rdv.customdata.budgetclient }}<br></span>
                            <span v-if="rdv.customdata.typeachatclient != ''"><strong>Type d'achat :</strong> {{ rdv.customdata.typeachatclient }}<br></span>
                            <span v-if="rdv.customdata.interetclient != ''"><strong>Niveau Intérêt du Client :</strong> {{ rdv.customdata.interetclient }}<br></span>
                            <span v-if="rdv.customdata.prochaineactionclient != ''"><strong>Prochaine action planifiée :</strong> {{ rdv.customdata.prochaineactionclient }}<br></span>
                            <span v-if="rdv.customdata.commentaireclient != ''"><strong>Commentaire :</strong> {{ rdv.customdata.commentaireclient }}<br></span>
                            <span v-if="rdv.customdata.statusappel == 'Effectué'"><strong>Intéressé par :</strong> <span v-for="model in rdv.customdata.modelsclient" v-bind:key="model.name"><span v-if="model.selection == true">{{model.name}}, </span></span></span>
                        </p>

                    </v-col>
                </v-row>
            </div>
        </v-container>
    </v-app>
</template>

<script>

    import NProgress from "nprogress";

    export default {
        name: 'ListeConnect',
        data() {
            return {
                actualdate: '',
                actualdatefr: '',
                loading: false,
                snackbar: false,
                errorMsg: '',
                rdvs: [],
                titrePrincipal: 'Rendez-vous du jour'
            }
        },
        computed: {
            sitename() {
                return this.$store.state.user.sitename
            },
            userId() {
                return this.$store.state.user.id
            }
        },
        methods: {
            setToday(){
                this.actualdate = new Date()
                this.actualdatefr = getFrenchDate(this.actualdate)
                this.getRdv(this.actualdate)
            },
            nextDay(){
                this.actualdate.setDate(this.actualdate.getDate() + 1)
                this.actualdatefr = getFrenchDate(this.actualdate)
                this.getRdv(this.actualdate)
            },
            previousDay(){
                this.actualdate.setDate(this.actualdate.getDate() - 1)
                this.actualdatefr = getFrenchDate(this.actualdate)
                this.getRdv(this.actualdate)
            },
            getRdv(date){
                NProgress.start()
                this.loading = true
                let params = {}

                let tmp = new Date(date)
                var month = parseInt(tmp.getMonth()) + 1
                var day = tmp.getDate()
                var year = tmp.getFullYear()
                let myDate = year+"-"+month+"-"+day

                params.action = 'getTodayRdv'
                params.date = myDate
                this.axios
                    .post(this.$store.state.rootUrl+'apiSales.php',params,{timeout: 10000})
                    .then((data) => {
                        console.log(data)
                        if(data.error === true){
                            console.log("Erreur")
                            // TODO : faire une snackbar
                            NProgress.done()
                            return false
                        }
                        let results = []

                        data.data.data.forEach((element) => {
                            results.push(element)
                        })
                        this.rdvs = results
                        NProgress.done()
                    })
                    .catch( error => {
                        console.log(error);
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            },
            init(){

                this.actualdatefr = getFrenchDate(new Date())
                this.actualdate = new Date()
                this.snackbar = false
                this.errorMsg =  ''

                this.getRdv(this.actualdate)

            },
            acceptRdv(rdv){
                if(!confirm('Etes vous sur de vouloir prendre en charge le prospect '+rdv.name+'?')){
                    return false;
                }
                NProgress.start()
                this.loading = true
                let params = {}

                params.action = 'acceptRdv'
                params.id = rdv.id
                this.axios
                    .post(this.$store.state.rootUrl+'apiSales.php',params,{timeout: 10000})
                    .then((data) => {
                        if(data.error === true){
                            console.log("Erreur")
                            this.errorMsg = 'Impossible de changer le status du RDV. Veuillez réessayer dans quelques instants'
                            this.snackbar = true
                            NProgress.done()
                            return false
                        }
                        this.getRdv(this.actualdate)
                        NProgress.done()
                    })
                    .catch( () => {
                        this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                        this.snackbar = true
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            }
        },
        mounted: function () {
            this.init()
        }
    }
    function getFrenchDate(todayTime) {
        var month = parseInt(todayTime.getMonth()) + 1;
        var day = todayTime.getDate();
        var year = todayTime.getFullYear();
        return day + "/" + month + "/" + year;
    }
</script>
